const news = [
  {
    date: "June 2026",
    content: "One paper accepted by ECCV'26"
  },
  {
    date: "February 2026",
    content: "Two papers accepted by CVPR'26"
  },
  {
    date: "January 2026",
    content: "🎉 Two papers accepted by ICLR'26"
  },
  {
    date: "January 2026",
    content: "Served as reviewer for ICML'26"
  },
  {
    date: "January 2026",
    content: "Served as reviewer for Pattern Recognition"
  },
  {
    date: "July 2025",
    content: "One paper accepted by ACMMM'25"
  },
  {
    date: "June 2025",
    content: "Selected for the 2025 Tencent Rhino-bird Research Elite Program!"
  },
  {
    date: "June 2025",
    content: "Served as reviewer for ICONIP'25"
  },
  {
    date: "April 2025",
    content: "Served as reviewer for ACMMM'25"
  },
  {
    date: "April 2025",
    content: "One paper accepted by Pattern Recognition Letters"
  }
];

export default news;
